import { Nilable } from "@shared/utils";
import { MensajeProcesador } from "../MensajeProcesador";

export class CampoProcesador implements MensajeProcesador {
    puedeProcesar(mensaje: string): boolean {
        return mensaje.includes("campo");
    }
    procesar(mensaje: string): Nilable<string> {
        return mensaje;
    }
}
